export { default } from './errorCard.component';